import {
  fetchClientInfo as fetchClientInfoApi,
  fetchAccessToken as fetchAccessTokenApi,
} from 'support/api/AdobeApi';
import safeLocalStorage from 'common/support/safeLocalStorage';
import { HttpClient, AdobeAccessTokenResponse } from 'support/api/api-types';
import { VideoCtvRedux } from 'store-types';
import { AppDispatch } from 'app-types';

export const ADOBE_CLIENT_INFO = 'ADOBE_CLIENT_INFO' as const;
export const ADOBE_ACCESS_TOKEN = 'ADOBE_ACCESS_TOKEN' as const;
export const CLIENT_INFO_STORAGE_KEY = 'adobeClientInfo';
const EXPIRY_BUFFER = 60 * 1000;

const getStoredClientInfoJson = () => {
  const clientInfoStorage = safeLocalStorage.getItem(CLIENT_INFO_STORAGE_KEY);
  return clientInfoStorage ? JSON.parse(clientInfoStorage) : null;
};

const fetchClientInfo = (host: string) => ({
  type: ADOBE_CLIENT_INFO,
  promise: (httpClient: HttpClient) => {
    return fetchClientInfoApi(httpClient, host).then(result => {
      safeLocalStorage.setItem(CLIENT_INFO_STORAGE_KEY, JSON.stringify(result));
      return result;
    });
  },
});

export const getAccessToken = () => async (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const host = getState().kitchenSink.data?.providers?.adobe?.authUrl;

  let clientInfo = getStoredClientInfoJson();
  if (!clientInfo) {
    clientInfo = await dispatch(fetchClientInfo(host));
  }

  let tokenInfo = getState().auth.adobe.accessToken;
  if (tokenInfo && tokenInfo.expiryMs - EXPIRY_BUFFER >= Date.now()) {
    return tokenInfo.token;
  }

  if (clientInfo) {
    tokenInfo = await dispatch<AdobeAccessTokenResponse>({
      type: ADOBE_ACCESS_TOKEN,
      promise: (httpClient: HttpClient) =>
        fetchAccessTokenApi(httpClient, host, clientInfo.id, clientInfo.secret),
    });

    return tokenInfo.token;
  }

  return null;
};
